
import { Component, Vue } from "vue-property-decorator";
import { UserService, StoreProductService } from "src/services";
import { Toast, Dialog } from "vant";
import { tools } from "src/utils";
import dayjs from "dayjs";
import sensors from "src/sensors";
import PackageList from './package-list.vue'

Component.registerHooks([
"beforeRouteEnter",
"beforeRouteLeave",
"beforeRouteUpdate" // for vue-router 2.2+
]);

@Component({
    components:
    {
      PackageList
    }
})
export default class PackageDetail extends Vue
{
  /**
   * 是否显示分享弹出框
   * @private
   * @returns boolean
   */
  private showSharePopup: boolean = false;

  /**
   * 前一个页面名称
   * @private
   * @returns void
   */
  private routeName: string = "";

  /**
   * 分享弹出框数据
   * @private
   * @returns any
   */
  private shareData: any = {
      name: "",
      price: null,
      marketPrice: null,
      qrCode: "",
      posterUrl: "",
      bannerUrl: ""
  };

  /**
   * 套餐详情
   * @private
   * @returns any
   */
   public packageDetail: any = {
      crossedPrice: null,
      id: null,
      mainImageId: null,
      mainImageUrl: "",
      name: "",
      price: null,
      productGroup:{},
      products:[],
      rightsDesc:"",
      rightsRemark:"",
      isPut:true
  };

  /**
     * 组件进来之前
     * @private
     * @returns void
     */
     private beforeRouteEnter(to, from, next): void
    {
        next(vm => {
            // 通过“vm”访问组件实例`　　//可以通过vm.name去访问data里面的name属性，跟this.name一样效果
            vm.routeName = from.name
        })
    }

  /**
   * 显示套餐对比
   * @protected
   * @returns boolean
   */
    public showComparePopup: boolean = false;


  /**
   * 权益id
   * @private
   * @returns string
   */
  private get rightsId(): string
  {
      return this.$route.query && (this.$route.query.id as string) || "";
  }


  /**
   * 组件创建
   * @private
   * @returns void
   */
  private created(): void
  {
      if(this.rightsId)
      {
        this.getPackageDetail(this.rightsId);
      }
  }

  protected mounted() {
    if(this.routeName == "rights-package-detail") {
        this.showComparePopup = true;
    }
  }


  /**
   * 获取套餐详情
   * @private
   * @returns void
   */
  private async getPackageDetail(id: any): Promise<void>
  {
      try
      {
          let {content: result} =  await StoreProductService.instance.getRightsDetail(id);

          if(result.data)
          {
            for (const key in this.packageDetail) {
                this.packageDetail[key] = result.data[key];
            }

            // 分享
            this.shareData.name = this.packageDetail.name;
            this.shareData.price = this.packageDetail.price;
            this.shareData.marketPrice = this.packageDetail.crossedPrice;
            this.shareData.qrCode = window.location.href;

            if(this.packageDetail && this.packageDetail.mainImageUrl)
            {
                this.shareData.bannerUrl = this.packageDetail.mainImageUrl || "";
                this.getUrl2base64(this.packageDetail.mainImageUrl);
            }
          }

      }
      catch(err)
      {
          Toast(err);
      }
  }

  /**
   * 权益详情
   * @private
   * @returns void
   */
  private onRightsDetail () {
    this.$router.push({name: 'rights-order-submit', query: {id: this.packageDetail.id}})
  }

  /**
   * 获取url获取base64
   * @public
   * @param {params}
   * @returns {Promise<IHttpResponse>}
   */
  public async getUrl2base64(url: string): Promise<void>
  {
      try
      {
          let {content: result} = await UserService.instance.url2base64(url);
          if(result.data)
          {
              this.shareData.posterUrl = "data:image/png;base64," + result.data;
          }
      }
      catch(err)
      {
          Toast(JSON.stringify(err));
      }
  }


   /**
     * 关闭弹窗
     * @protected
     * @returns void
     */
     protected closeComparePopup() {
        this.showComparePopup = false
     }

     /**
     * 跳转详情
     * @private
     * @returns void
     */
    private onGoDetail (item: any) {
        // 实物
        if (item.orderKind === 4) {
            this.$router.push({name: 'goodsDetail', query: { id: item.rightsProductId, rightsId: item.rightsId, isDetail: 'true', isRightsIdToBuy: item.rightsId }});
        }
        // 医疗服务
        else if (item.orderKind === 6) {
            this.$router.push({name: 'medical', query: { id: item.rightsProductId, rightsId: item.rightsId, isDetail: 'true', isRightsIdToBuy: item.rightsId }});
        }
        // 健康险
        else if (item.orderKind === 8) {
            this.$router.push({name: 'healthInsuranceDetail', query: { id: item.rightsProductId, rightsId: item.rightsId, isDetail: 'true', isRightsIdToBuy: item.rightsId }});
        }
    }

}
